import './Theme.Wrapper.Breadcrumbs.scss';
export default 'ThemeWrapperBreadcrumbs';
